<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="800" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Tạo sổ liên lạc
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div class="mx-0" v-if="step === 'preview'">
          <div class="d-flex flex-column">
            <div class="mb-4">
              <span><b>Nhóm được chọn</b></span
              >: {{ students.length }} Học viên
            </div>
            <div class="mb-2">
              Hệ thống sẽ tạo sổ liên lạc cho các học viên được chọn. Vui lòng kiểm tra lại thông tin và bấm
              <span><b>[Tạo]</b></span> để tiếp tục.
            </div>
            <div>
              <span class="error--text">*</span>&nbsp;<b>Lưu ý</b>:<br />
              Các học viên thiếu <span><b>SĐT mặc định</b></span> sẽ không được gửi lên hệ thống tạo sổ liên lạc.
            </div>
          </div>

          <v-card class="mt-4" outlined v-if="students.length">
            <v-data-table
              :headers="headers"
              :items="students"
              :footer-props="{
                'items-per-page-text': 'Học viên mỗi trang',
                'items-per-page-all-text': 'Tất cả',
                'items-per-page-options': students.length > 100 ? [5, 15, 30] : [5, 15, -1],
              }"
            >
              <template v-slot:top>
                <div class="px-4 py-2 green--text font-weight-medium">Học viên sẽ được gửi tạo sổ liên lạc</div>
              </template>
              <template v-slot:[`footer.page-text`]="items">
                {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                {{ items.itemsLength }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <CardStudentName :student="item" link />
              </template>
              <template v-slot:[`item.dob`]="{ item }">
                <span>{{ item.dob | ddmmyyyy }}</span>
              </template>
              <template v-slot:[`item.classes`]="{ item }">
                <router-link
                  style="text-decoration: none"
                  :to="'/class/' + (item.currentClass && item.currentClass.id)"
                >
                  <span v-if="item.currentClass">{{ item.currentClass.title }}</span>
                </router-link>
              </template>
              <template v-slot:[`item.phone`]="{ item }">
                <span>{{ item.phone || '—' }}</span>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-chip v-if="item.contactBook" :color="item | getContactBookStatusColor" small class="white--text">
                  {{ item | getContactBookStatus }}
                </v-chip>
                <span v-else class="grey--text">Chưa có sổ</span>
              </template>
            </v-data-table>
          </v-card>
        </div>

        <div class="mx-0" v-else>
          <div class="d-flex flex-column">
            <div>
              Tổng số học viên đã chọn: <b>{{ resultStudents.length }}</b>
            </div>
            <div>
              Đã gửi xử lý: <b>{{ submittedStudents.length }}</b>
            </div>
            <div>
              Tạo thành công: <span class="green--text">{{ result.success }}</span>
            </div>
            <div>
              Đã bỏ qua: <span class="orange--text">{{ result.skipped }}</span>
            </div>
            <div>
              Thất bại: <span class="red--text">{{ result.failed.length }}</span>
            </div>
          </div>

          <v-card class="mt-4" outlined v-if="failedStudents.length">
            <v-data-table
              :headers="errorHeaders"
              :items="failedStudents"
              :footer-props="{
                'items-per-page-text': 'Học viên mỗi trang',
                'items-per-page-all-text': 'Tất cả',
                'items-per-page-options': failedStudents.length > 100 ? [5, 15, 30] : [5, 15, -1],
              }"
            >
              <template v-slot:top>
                <div class="px-4">Học viên tạo lỗi</div>
              </template>
              <template v-slot:[`footer.page-text`]="items">
                {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                {{ items.itemsLength }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <CardStudentName :student="item" link />
              </template>
              <template v-slot:[`item.dob`]="{ item }">
                <span>{{ item.dob | ddmmyyyy }}</span>
              </template>
              <template v-slot:[`item.classes`]="{ item }">
                <router-link
                  style="text-decoration: none"
                  :to="'/class/' + (item.currentClass && item.currentClass.id)"
                >
                  <span v-if="item.currentClass">{{ item.currentClass.title }}</span>
                </router-link>
              </template>
              <template v-slot:[`item.phone`]="{ item }">
                <span>{{ item.phone || '—' }}</span>
              </template>
              <template v-slot:[`item.error`]="{ item }">
                <span class="red--text">{{ item.error }}</span>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn v-if="step === 'preview'" class="ma-2 px-4" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="step === 'preview'"
          class="ma-2"
          dark
          depressed
          color="primary"
          :disabled="!students.length"
          @click="send"
        >
          Tạo
        </v-btn>
        <v-btn v-if="step === 'noti'" class="ma-2" dark depressed @click="cancel" color="primary">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ContactBook } from '@/plugins/api'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  components: { CardStudentName },
  props: {
    students: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'Học viên', value: 'name', align: 'left', sortable: false },
        { text: 'Ngày sinh', value: 'dob', align: 'left', sortable: false },
        { text: 'Lớp', value: 'classes', align: 'left', sortable: false },
        { text: 'SĐT', value: 'phone', align: 'left', sortable: false },
        { text: 'Trạng thái', value: 'status', align: 'left', sortable: false },
      ],
      errorHeaders: [
        { text: 'Học viên', value: 'name', align: 'left', sortable: false },
        { text: 'Ngày sinh', value: 'dob', align: 'left', sortable: false },
        { text: 'Lớp', value: 'classes', align: 'left', sortable: false },
        { text: 'SĐT', value: 'phone', align: 'left', sortable: false },
        { text: 'Lỗi', value: 'error', align: 'left', sortable: false },
      ],
      dialog: false,
      step: 'preview',
      result: { success: 0, skipped: 0, failed: [] },
      failedStudents: [],
      submittedStudents: [],
    }
  },
  computed: {
    resultStudents() {
      return this.step === 'noti' ? this.submittedStudents : this.students
    },
  },
  methods: {
    getStudentId(student) {
      return student.id || student._id || ''
    },
    open() {
      this.reset()
      this.dialog = true
    },
    async send() {
      this.$loading.active = true
      this.submittedStudents = [...this.students]
      const payload = this.submittedStudents.map(this.getStudentId).filter(Boolean)
      let shouldRefresh = false

      try {
        const data = await ContactBook.bulkActivate(payload)
        shouldRefresh = true
        const failed = data.failed || []
        this.result = {
          success: data.success || 0,
          skipped: data.skipped || 0,
          failed,
        }
        this.failedStudents = failed.map(f => {
          const student = this.submittedStudents.find(s => this.getStudentId(s) === f.studentId)
          return student ? { ...student, error: f.error } : { name: f.studentId, error: f.error }
        })
      } catch (_) {
        this.result = { success: 0, skipped: 0, failed: [] }
        this.failedStudents = this.submittedStudents.map(s => ({ ...s, error: 'Lỗi hệ thống' }))
      } finally {
        this.$loading.active = false
      }

      this.step = 'noti'
      this.$emit('done', { shouldRefresh })
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    reset() {
      this.step = 'preview'
      this.result = { success: 0, skipped: 0, failed: [] }
      this.failedStudents = []
      this.submittedStudents = []
    },
  },
}
</script>
